import SearchInput from '../../components/SearchInput';

function TaskFilters({
    taskFilters,
    setTaskFilters,
    lockedWorkspaceName,
    visibleWorkspaces,
    companyUsers,
    getUserLabel,
    taskStatusLabels,
    taskTags,
    marketplaces,
    deals,
    onRefresh
}) {
    return (
        <div className="tasks__filters-panel">
            <div className="tasks__filters-head">Фильтры</div>
            <div className="tasks__filters-toggles">
                <button
                    type="button"
                    className={taskFilters.overdue ? 'active' : ''}
                    onClick={() =>
                        setTaskFilters({
                            ...taskFilters,
                            overdue: !taskFilters.overdue
                        })
                    }
                >
                    Просрочено
                </button>
                <button
                    type="button"
                    className={taskFilters.noDue ? 'active' : ''}
                    onClick={() =>
                        setTaskFilters({
                            ...taskFilters,
                            noDue: !taskFilters.noDue
                        })
                    }
                >
                    Без срока
                </button>
                <button
                    type="button"
                    className={taskFilters.showDone ? 'active' : ''}
                    onClick={() =>
                        setTaskFilters({
                            ...taskFilters,
                            showDone: !taskFilters.showDone
                        })
                    }
                >
                    Выполненные
                </button>
            </div>
            <div className="tasks__filters">
                <label>
                    Поиск
                    <SearchInput
                        className="tasks__filters-input"
                        value={taskFilters.search}
                        onChange={(value) =>
                            setTaskFilters({
                                ...taskFilters,
                                search: value
                            })
                        }
                    />
                </label>
                <label>
                    Проект
                    <select
                        value={taskFilters.workspaceId}
                        onChange={(event) =>
                            setTaskFilters({
                                ...taskFilters,
                                workspaceId: event.target.value
                            })
                        }
                    >
                        <option value="">{lockedWorkspaceName || 'Все'}</option>
                        {visibleWorkspaces.map((workspace) => (
                            <option key={workspace.id} value={workspace.id}>
                                {workspace.name}
                            </option>
                        ))}
                    </select>
                </label>
                <label>
                    Исполнитель
                    <select
                        value={taskFilters.assigneeId}
                        onChange={(event) =>
                            setTaskFilters({
                                ...taskFilters,
                                assigneeId: event.target.value
                            })
                        }
                    >
                        <option value="">Все</option>
                        {companyUsers.map((item) => (
                            <option key={item.id} value={item.id}>
                                {getUserLabel(item)}
                            </option>
                        ))}
                    </select>
                </label>
                <label>
                    Постановщик
                    <select
                        value={taskFilters.creatorId}
                        onChange={(event) =>
                            setTaskFilters({
                                ...taskFilters,
                                creatorId: event.target.value
                            })
                        }
                    >
                        <option value="">Все</option>
                        {companyUsers.map((item) => (
                            <option key={item.id} value={item.id}>
                                {getUserLabel(item)}
                            </option>
                        ))}
                    </select>
                </label>
                <label>
                    Статус
                    <select
                        value={taskFilters.status}
                        onChange={(event) =>
                            setTaskFilters({
                                ...taskFilters,
                                status: event.target.value
                            })
                        }
                    >
                        <option value="">Все</option>
                        {Object.entries(taskStatusLabels).map(([key, label]) => (
                            <option key={key} value={key}>
                                {label}
                            </option>
                        ))}
                    </select>
                </label>
                <label>
                    Тег
                    <select
                        value={taskFilters.tag}
                        onChange={(event) =>
                            setTaskFilters({
                                ...taskFilters,
                                tag: event.target.value
                            })
                        }
                    >
                        <option value="">Все</option>
                        {taskTags.map((tag) => (
                            <option key={tag} value={tag}>
                                {tag}
                            </option>
                        ))}
                    </select>
                </label>
                <label>
                    Кабинет
                    <select
                        value={taskFilters.cabinetId}
                        onChange={(event) =>
                            setTaskFilters({
                                ...taskFilters,
                                cabinetId: event.target.value
                            })
                        }
                    >
                        <option value="">Все</option>
                        {marketplaces.map((account) => (
                            <option key={account.id} value={account.id}>
                                {account.account_name}
                            </option>
                        ))}
                    </select>
                </label>
                <label>
                    Сделка
                    <select
                        value={taskFilters.dealId}
                        onChange={(event) =>
                            setTaskFilters({
                                ...taskFilters,
                                dealId: event.target.value
                            })
                        }
                    >
                        <option value="">Все</option>
                        {(deals || []).map((deal) => (
                            <option key={deal.id} value={deal.id}>
                                {deal.title}
                            </option>
                        ))}
                    </select>
                </label>
                <label>
                    Создано с
                    <input
                        type="date"
                        value={taskFilters.createdFrom}
                        onChange={(event) =>
                            setTaskFilters({
                                ...taskFilters,
                                createdFrom: event.target.value
                            })
                        }
                    />
                </label>
                <label>
                    Создано по
                    <input
                        type="date"
                        value={taskFilters.createdTo}
                        onChange={(event) =>
                            setTaskFilters({
                                ...taskFilters,
                                createdTo: event.target.value
                            })
                        }
                    />
                </label>
                <label>
                    Срок с
                    <input
                        type="date"
                        value={taskFilters.dueFrom}
                        onChange={(event) =>
                            setTaskFilters({
                                ...taskFilters,
                                dueFrom: event.target.value
                            })
                        }
                    />
                </label>
                <label>
                    Срок по
                    <input
                        type="date"
                        value={taskFilters.dueTo}
                        onChange={(event) =>
                            setTaskFilters({
                                ...taskFilters,
                                dueTo: event.target.value
                            })
                        }
                    />
                </label>
                <button type="button" className="ghost" onClick={onRefresh}>
                    Обновить
                </button>
            </div>
        </div>
    );
}

export default TaskFilters;
